import { Eye, EyeOff, Save, Expand, Minimize } from 'lucide-react';
import { useEditorStore } from '../../../../store/editorStore';

interface EditorToolbarProps {
  onPreviewToggle: () => void;
  showPreview: boolean;
}

export default function EditorToolbar({ onPreviewToggle, showPreview }: EditorToolbarProps) {
  const { isFullscreen, toggleFullscreen } = useEditorStore();

  return (
    <div className="flex items-center justify-between border-b bg-white p-2">
      <div className="flex items-center space-x-2">
        <button
          type="button"
          onClick={onPreviewToggle}
          className="p-2 hover:bg-gray-100 rounded-md flex items-center space-x-2 text-sm"
          title={showPreview ? '隐藏预览' : '显示预览'}
        >
          {showPreview ? (
            <>
              <EyeOff className="w-4 h-4" />
              <span>隐藏预览</span>
            </>
          ) : (
            <>
              <Eye className="w-4 h-4" />
              <span>显示预览</span>
            </>
          )}
        </button>

        <button
          type="button"
          onClick={toggleFullscreen}
          className="p-2 hover:bg-gray-100 rounded-md flex items-center space-x-2 text-sm"
          title={isFullscreen ? '退出全屏' : '全屏编辑'}
        >
          {isFullscreen ? (
            <>
              <Minimize className="w-4 h-4" />
              <span>退出全屏</span>
            </>
          ) : (
            <>
              <Expand className="w-4 h-4" />
              <span>全屏编辑</span>
            </>
          )}
        </button>
      </div>

      <button
        type="button"
        onClick={() => {}} // 保存功能将通过父组件传入
        className="p-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md flex items-center space-x-2 text-sm"
      >
        <Save className="w-4 h-4" />
        <span>保存</span>
      </button>
    </div>
  );
}